import { useAuth } from "../../../api/services/auth";
import { logout } from "../../../api/services/logoutUser";
import { userPermissions } from "../../../enums";
import NavItems from "./navItems";

const ConsultantNav = () => {
    const { permission } = useAuth();

    // all routes array along with permission and roles
    const routes = [
        { path: "/dashboard", label: "Dashboard" },
        ...((permission?.some(p => (p.name === userPermissions.CASES_LIST)))
            ? [{ path: "/cases-directory", label: "Case Directory" }]
            : []
        ),
        ...((permission?.some(p => (p.name === userPermissions)))
            ? [{ path: "/case-log", label: "Case Log" }]
            : []
        ),
        { path: "/", label: "Divider" },
        ...((permission?.some(p => (p.name === userPermissions.CASES_LIST)))
            ? [{ path: "/draft-cases", label: "Draft Cases" }]
            : []
        ),
        ...((permission?.some(p => (p.name === userPermissions.CASES_LIST)))
            ? [{ path: "/published-cases", label: "Published Cases" }]
            : []
        ),
        ...((permission?.some(p => (p.name === userPermissions.CASES_LIST)))
            ? [{ path: "/upcoming-cases", label: "Scheduled Cases" }]
            : []
        ),
        ...((permission?.some(p => (p.name === userPermissions.CASES_LIST)))
            ? [{ path: "/pending-review", label: "Pending Review" }]
            : []
        ),
        ...((permission?.some(p => (p.name === userPermissions.PENDING_REVIEW_BY_ME)))
            ? [{ path: "/pending-review-by-me", label: "Pending Review by me" }]
            : []
        ),
        ...((permission?.some(p => (p.name === userPermissions.CASES_LIST)))
            ? [{ path: "/discuss-cases", label: "For Discussion" }]
            : []
        ),
        ...((permission?.some(p => (p.name === userPermissions.CASES_MY_CASES)))
            ? [{ path: "/my-cases", label: "My Cases" }]
            : []
        ),
        ...((permission?.some(p => (p.name === userPermissions.CASES_LIST)))
            ? [{ path: "/approved-cases", label: "Approved Cases" }]
            : []
        ),
        ...((permission?.some(p => (p.name === userPermissions.CASES_LIST)))
            ? [{ path: "/cases-for-archive", label: "Cases for Archive" }]
            : []
        ),
        ...((permission?.some(p => (p.name === userPermissions.CASES_LIST)))
            ? [{ path: "/archived-cases", label: "Archived Cases" }]
            : []
        ),
        ...((permission?.some((p) => p.name === userPermissions.FLAGGED_CASES_CLOSED) && (permission?.some((p) => p.name === userPermissions.FLAGGED_CASES_OPENED)))
            ? [{ path: "/flagged-cases", label: "Flagged Cases" }]
            : []
        ),
        { path: "/", label: "Divider" },
        ...((permission?.some(p => (p.name === userPermissions.NOTIFICATIONS_LIST)))
            ? [{ path: "/notifications", label: "Notifications" }]
            : []
        ),
        ...((permission?.some(p => (p.name === userPermissions.CASES_STORE)))
            ? [{ path: "/upload-case", label: "Upload Case" }]
            : []
        ),
        ...(permission?.some((p) => p.name === userPermissions.CONTACT_REQUEST_LIST)
            ? [{ path: "/support-request", label: "Support Request" }]
            : []),
        ...((permission?.some(p => (p.name === userPermissions.PROFILE_UPDATE)))
            ? [{ path: "/profile", label: "Profile" }]
            : []
        ),
        { path: "/log-out", label: "Log Out", onClick: logout },
    ];

    return <NavItems routes={routes} />;
}

export default ConsultantNav;